/**
 *  Ensure that text is wrapped in paragraph for correct formatting.
 * @param {string} value
 * @return {string}
 */
const makeParagraph = value => {
    const valueString = value.toString();
    const containsHTML = /<[a-z][\s\S]*>/i.test(valueString);

    if (containsHTML) {
        return valueString;
    }

    return `<p>${valueString}</p>`;
};

export default makeParagraph;
